import forEach from "lodash/forEach";
import filter from "lodash/filter";
import isNil from "lodash/isNil";
export default function setParentNodes({ graph, jsonGraphModel, nodeMap }) {
    const nodesWithParentId = filter(jsonGraphModel.Nodes, nodeData => !isNil(nodeData.ParentId));
    forEach(nodesWithParentId, nodeData => {
        try {
            const node = nodeMap.get(nodeData.Id);
            const parent = nodeData.ParentId ? nodeMap.get(nodeData.ParentId) : undefined;
            if (node && parent) {
                graph.setParent(node, parent);
            }
        }
        catch (ex) {
            console.error(`Parent setting failed for node: ${nodeData.Id}`, ex);
        }
    });
}
